import { TabContent, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledTabContent = styled(TabContent) `
  padding-top: ${themeGet('spacing.2xl')};
`;
